(function () {
  const blog = {
    init() {
      if (document.querySelector('main.blog') !== null) {
        console.log('Initializing Blog...');
        // because this is the only way to reference it in removeEventList...
        this.destroyBinded = this.destroy.bind(this);

        this.setUpListeners();
      }
    },

    setUpListeners() {
      PubSub.subscribe('page.transitionStart', this.destroyBinded);
    },

    destroy() {
      console.log('Destroy: blog');

      PubSub.unsubscribe('page.transitionStart', this.destroyBinded);
    }
  };

  Object.assign(blog, window.tangleweb);

  blog.init();
  PubSub.subscribe('page.inDOM', blog.init.bind(blog));
})();
